import cn from "classnames";

import { IconProps } from "./Icon.types";

import styles from "./Icon.module.scss";

const Icon = ({
  className,
  as: CurrentIcon,
  type = "default",
  width,
  height,
  boxSize = 16,
  color,
  fill,
  onClick,
  isDisabled = false
}: IconProps) => {
  const currentWidth = width ?? boxSize;
  const currentHeight = height ?? boxSize;

  return (
    <CurrentIcon
      style={{
        width: currentWidth,
        height: currentHeight,
        color,
        fill
      }}
      className={cn(
        styles.icon,
        {
          [styles["icon-button"]]: type === "button",
          [styles["icon-button__disabled"]]: isDisabled
        },
        className
      )}
      onClick={!isDisabled ? onClick : undefined}
    />
  );
};

export default Icon;
